export class OpportunityBoardConfig {
  private allowedTransitions = {
    Lost: [],
    Won: [],
    Presented: ["Won", "Lost"]
  };

  isTransitionAllowed(sourceColumnName: string, destColumnName: string) {
    const allowedDestinations = this.allowedTransitions[sourceColumnName];
    return allowedDestinations.includes(destColumnName);
  }
}
